import './assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import { authGuard, initRouter } from './router'
import i18n from './core/locales/i18n'
import { installOrgAwareTranslationHook } from './core/locales/org-aware-translation-hook'
import { vTooltip } from './core/components/base/tooltip/tooltip-directive'
import { createPinia } from 'pinia'
import { useAuthStore } from './stores/auth.store'
import { vAutoFocus } from './core/directives/auto-focus/auto-focus.directive'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

const authStore = useAuthStore()

authStore.initKeycloak().then(async () => {
  const router = initRouter()
  router.beforeEach(authGuard)
  app.use(router).use(i18n)
  installOrgAwareTranslationHook(app, i18n)
  app.directive('tooltip', vTooltip)
  app.directive('auto-focus', vAutoFocus)
  await router.isReady()
  app.mount('#app')
})
